export default __webpack_public_path__ + "static/media/user.75dabc23.svg";